export const buildCustomerAccessLink = ({ companySlug, reservationId }) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const slug = companySlug || 'empresa';
  return `${origin}/cliente/${slug}?reservation=${reservationId}`;
};

export const buildCustomerAccessMessage = ({ companyName, reservationId, accessLink }) => {
  return [
    `Olá! Sua reserva foi confirmada com ${companyName || 'nossa empresa'}.`,
    `Número da reserva: ${reservationId}`,
    `Acesse seu painel cliente aqui: ${accessLink}`,
    'Faça login com Google e acompanhe sua reserva, verifique os detalhes e acompanhe o status.'
  ].join(' ');
};
